import { render, staticRenderFns } from "./ArticlesOverview.vue?vue&type=template&id=3888d15f&"
import script from "./ArticlesOverview.vue?vue&type=script&lang=js&"
export * from "./ArticlesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports